module.exports = __webpack_public_path__ + "img/second_appointment_text2.5c3760f1.png";